<template>
  <div class="forward-editor-main">
    <div class="forward-info">
      转发：{{ forwardInfo }}
    </div>
    <div class="editor-wrapper">
      <LiveEditor ref="liveEditor"
                  :disabled="disabled"
                  @submit="submitLive"
                  :enablePictureUpload="false"
                  :enableVideoUpload="false"></LiveEditor>
    </div>
  </div>
</template>

<script>
    import {uuid} from "../../js/utils/uuid";
    import setting from "../../config/setting";
    import LiveEditor from "../component/LiveEditor"

    export default {
        name: "ForwardEditor",
        components: {LiveEditor},
        props: {
            disabled: {
                default: false
            },
            forwardInfo: {
                type: String,
                required: true
            }
        },
        data(){
            return {
                faceId: uuid(),
                atId: uuid(),
            }
        },
        methods: {
            submitLive(live) {
                this.$emit("submit", live);
            },
            focus() {
                this.$refs.liveEditor.focus();
            },
            clean() {
                this.$refs.liveEditor.clean();
            }
        }
    }
</script>

<style scoped>
  .forward-info {
    word-break: break-all;
    white-space: normal;
    border-radius: 4px;
    padding: 4px 8px;
    background: #ededed;
    margin-bottom: 8px;
    border-left: 8px solid orange;
    font-style: italic;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/ForwardEditor.vue